<template>
  <div class="container guarantee-page" style="padding:10px;background:#33333311;">
    <h2 style="margin-bottom:6px">履约保证金管理</h2>
    <div style="font-size:12px;color:var(--subtext3);font-weight:bold;margin-bottom:10px">
      履约保证管理
    </div>
    <div class="flex-wrap">
      <Input
        search
        style="width:280px"
        v-model="filter.searchText"
        placeholder="客户 / 项目 / 合同编号 / 序号"
        clearable
        @on-enter="noop"
      />
      <Button type="primary" style="margin-left:10px" icon="md-refresh" @click="getData">刷新</Button>
      <span style="margin-left:12px;font-size:12px;color:var(--subtext3);align-self:center;">
        共 {{ filteredItems.length }} 条
      </span>
    </div>
    <div class="guarantee-table-wrap">
      <BaseTable
        ref="table"
        :columns="columns"
        :loading="loading"
        :data="filteredItems"
        border
        paged
        :page-size="pageSize"
        :page="page"
        :option="{ key: 'id' }"
        @event="handleTableEvent"
      />
    </div>
  </div>
</template>

<script>
import UTIL from '@/utils';
import CMR from '@/components/cm/render';

const MOCK_JSON = (process.env.BASE_URL || '/').replace(/\/?$/, '/') + 'contracts-admin-mock/performance-guarantee-records.json';

export default {
  routerOption: {
    as_default: true,
  },
  data() {
    return {
      items: [],
      loading: false,
      page: 1,
      pageSize: 50,
      filter: {
        searchText: '',
      },
    };
  },
  computed: {
    filteredItems() {
      const q = (this.filter.searchText || '').trim().toLowerCase();
      if (!q) {
        return this.items;
      }
      return this.items.filter((row) => {
        const blob = [
          row.code,
          row.client_name,
          row.name,
          row.contract_ref,
          row.deposit_type,
          row.seal_status,
          row.business_type,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return blob.includes(q);
      });
    },
    columns() {
      return [
        {
          type: 'text',
          key: 'code',
          title: '编号',
          width: 72,
          fixed: 'left',
          option: { align: 'center' },
          render: CMR.renderCode,
        },
        {
          title: '客户单位',
          key: 'client_name',
          minWidth: 200,
          render: (h, { row }) =>
            h('span', { attrs: { title: row.client_name || '' } }, row.client_name || '—'),
        },
        {
          title: '类型',
          key: 'deposit_type',
          width: 88,
          align: 'center',
          render: (h, { row }) => h('span', row.deposit_type || '—'),
        },
        {
          title: '项目名称',
          key: 'name',
          minWidth: 160,
          tree: true,
          fixed: 'left',
          render: (h, { row }) => {
            const icon = h('BaseIcon', {
              props: { icon: 'Building-', color: 'var(--subtext3)', size: 18 },
              style: 'margin-right:6px;',
            });
            return h('div', { class: 'flex-wrap flex-left',style:'padding-left:5px' }, [
              icon,
              h('span', { attrs: { title: row.name } }, row.name || '—'),
            ]);
          },
        },
        {
          title: '合同编号',
          key: 'contract_ref',
          width: 120,
          render: (h, { row }) =>
            h('span', { attrs: { title: row.contract_ref || '' } }, row.contract_ref || '—'),
        },
        {
          title: '台账状态',
          key: 'seal_status',
          width: 88,
          align: 'center',
          render: (h, { row }) => {
            const t = (row.seal_status || '').trim();
            return h('span', t || '—');
          },
        },
        {
          type: 'number',
          title: '履约保证金',
          key: 'guarantee_amount',
          width: 130,
          align: 'right',
          option: {
            sumable: true,
            formatter: (e) => '¥ ' + UTIL.formatSalary(e),
            type: 'fullAmount',
          },
        },
        {
          title: '是否退还',
          width: 100,
          align: 'center',
          render: (h, { row }) => {
            const refunded = row.refunded;
            return h(
              'Tag',
              { props: { color: refunded ? 'success' : 'default' } },
              refunded ? '已退还' : '未退还',
            );
          },
        },
      ];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    noop() {},
    getData() {
      this.loading = true;
      fetch(MOCK_JSON)
        .then((r) => {
          if (!r.ok) {
            throw new Error(r.statusText || String(r.status));
          }
          return r.json();
        })
        .then((payload) => {
          const list = Array.isArray(payload.data)
            ? payload.data
            : Array.isArray(payload.items)
              ? payload.items
              : [];
          
          this.items = list.filter(v=>v.client_name);
          this.page = 1;
          this.$nextTick(() => {
            const t = this.$refs.table;
            if (t && typeof t.calcTableHeight === 'function') {
              t.calcTableHeight();
            }
          });
        })
        .catch((e) => {
          this.Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleTableEvent(e) {
      if (e.type === 'page-change') {
        this.page = e.data;
      } else if (e.type === 'page-size-change') {
        this.pageSize = e.data;
        this.page = 1;
      }
      this.$nextTick(() => {
        const t = this.$refs.table;
        if (t && typeof t.calcTableHeight === 'function') {
          t.calcTableHeight();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.guarantee-page {
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-sizing: border-box;
}

.guarantee-table-wrap {
  flex: 1;
  min-height: 0;
  position: relative;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.guarantee-table-wrap /deep/ .gz-table {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
